import data from './data'

export const findProjectIndex = (id) => {
  return data.projects.findIndex(p => (String(p.idNum) === String(id)))
}

export const findNextProjectId = (currentId) => {
  const index = findProjectIndex(currentId)
  if (index === -1) return null
  if (index + 1 < data.projects.length) {
    return data.projects[index + 1].idNum
  } else {
    return null
  }
}

export const findPreviousProjectId = (currentId) => {
  const index = findProjectIndex(currentId)
  if (index === -1) return null
  if (index - 1 >= 0) {
    return data.projects[index - 1].idNum
  } else {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/modules/projects/ProjectsUtils.js